"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Tab = _interopRequireDefault(require("../../../components/common/Tab/Tab"));
var _cssClassesHelper = require("../../../helpers/cssClassesHelper");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var orderEntryClasses = (0, _cssClassesHelper.getBEMClasses)('order-entry');
var TradingLayout468Px = function TradingLayout468Px(props) {
  var _useTranslation = (0, _reactI18next.useTranslation)("core"),
    t = _useTranslation.t;
  var OrderEntry = props.OrderEntry,
    InstrumentPositions = props.InstrumentPositions,
    RecentTrades = props.RecentTrades,
    OrderBook = props.OrderBook;
  var _getPanes = function _getPanes() {
    return [{
      menuItem: t("Order Entry"),
      render: function render() {
        return /*#__PURE__*/_react["default"].createElement(OrderEntry, null);
      }
    }, {
      menuItem: t("Order Book"),
      render: function render() {
        return /*#__PURE__*/_react["default"].createElement(OrderBook, null);
      }
    }, {
      menuItem: t("Trades"),
      render: function render() {
        return /*#__PURE__*/_react["default"].createElement(RecentTrades, null);
      }
    }, {
      menuItem: t("Balances"),
      render: function render() {
        return /*#__PURE__*/_react["default"].createElement(InstrumentPositions, {
          showTitle: false
        });
      }
    }];
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: orderEntryClasses('container')
  }, /*#__PURE__*/_react["default"].createElement(_Tab["default"], {
    panes: _getPanes(),
    customClass: "trading-layout"
  }));
};
TradingLayout468Px.propTypes = {
  "short": _propTypes["default"].bool,
  OrderBook: _propTypes["default"].func.isRequired,
  RecentTrades: _propTypes["default"].func.isRequired,
  OrderEntry: _propTypes["default"].func.isRequired,
  InstrumentPositions: _propTypes["default"].func.isRequired
};
TradingLayout468Px.defaultProps = {
  "short": false
};
var _default = exports["default"] = TradingLayout468Px;